import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
/* 登录页 */
import login from '../views/login'
/* 大屏 */
import dataScreen from '../views/dataScreen/index'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  }, {
    path: '/login',
    name: 'login',
    component: login
  }, {
    path: '/dataScreen',
    name: 'dataScreen',
    component: dataScreen
  },
  {
    path: '/home',
    name: 'home',
    meta: {
      requireAuth: true
    },
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = new VueRouter({
  // base:"/dk/",
  routes
})

export default router
